/**
 * Configuração do React Query
 * 
 * Centraliza a configuração do QueryClient
 */

import { QueryClient } from '@tanstack/react-query';

// Configuração padrão do QueryClient
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Tempo que os dados ficam em cache (5 minutos)
      staleTime: 5 * 60 * 1000,
      // Tempo no cache após sair do DOM (TanStack Query v5: gcTime)
      gcTime: 10 * 60 * 1000,
      // Retry automático em caso de erro
      retry: 2,
      // Refetch quando a janela ganha foco
      refetchOnWindowFocus: true,
      // Refetch quando reconecta à internet
      refetchOnReconnect: true,
      // Não refetch automaticamente em background
      refetchOnMount: true,
    },
    mutations: {
      // Retry automático em caso de erro
      retry: 1,
    },
  },
});

export default queryClient;

